// Nav Context
import { createContext } from "react";

export const ContextNav = createContext<string | null | string[][]>(null);
